import { render, staticRenderFns } from "./ErrorMessageCard.vue?vue&type=template&id=d49f7f3a&scoped=true&"
import script from "./ErrorMessageCard.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageCard.vue?vue&type=style&index=0&id=d49f7f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49f7f3a",
  null
  
)

export default component.exports